<template lang="pug">
	.settings-localization
		.sidebar-settings(v-if="setting")
			.clearfix.mt-4(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner'")
				span {{setting.title}}
				div
					small.text-muted {{setting.description}}
				select.custom-select.custom-select-sm(:name="setting.codename" v-on:change="Settings.setSettingValue(setting.codename, getLocaleByLanguage($event.target.value))")
					option(:selected="language === 'auto'" value="auto") Choose locale automatically
					option(v-for="(lng, index) in Languages" :selected="language === index" :value="lng") {{lng}}
			.messages-area.clearfix.mt-4
				span.messages-area-title {{this.Languages[messagesLanguage]}} messages
					span.flag-icon(:class="messagesLanguage")
				div
					small.text-muted Put {{this.Languages[messagesLanguage].toLowerCase()}} text messages here. Press on message name to change details
				.lang-chooser-control
					.options-button(v-pseudo-modal-show="'localization-messages-dropdown'")
						i.fa.fa-navicon
					.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'localization-messages-dropdown'")
						.dropdown-item(v-for="(lng, index) in Languages" @click="setMessagesLanguage(index)")
							span.flag-icon(:class="index")
							span.flag-title {{lng}}
				.messages
					span.split-input(v-for="(text, message_key) in Texts['en']")
						span.text-key.split-title.text-caption(:class="{expanded: expandedTextCodename === message_key, 'has-expanded': !!expandedTextCodename}" @click="expandTextSettings(message_key)")
							.title {{message_key.toUpperCase()}}
							button.form-control.form-control-sm.i.fa.fa-rotate-left.reset-message(v-if="isChangedMessage(message_key)" @click="resetMessage(message_key)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reset text to default'}")
						.text-controls(:class="{expanded: expandedTextCodename === message_key}" v-pseudo-modal-name="'text-settings'")
							textarea(:ref="'messageTextarea-' + message_key" :value="getMessage(message_key)" v-on:mousedown="textAreaOnDown($event)" v-on:keypress="changeMessage(message_key, $event.target.value, 1000)" v-on:keyup="changeMessage(message_key, $event.target.value, 300)" v-on:change="changeMessage(message_key, $event.target.value, 0)")
							span.style-split-input(v-for="(style_value, style_name) in text.styles" v-if="style_name !== 'type' && style_value !== '#deleted#'")
								.known-props(v-if="Metadata.TextStylesByCodename[style_name]")
									span.text-key.split-style-title.text-muted {{(Metadata.TextStylesByCodename[style_name]['type'] === 'number') ? Metadata.TextStylesByCodename[style_name]['title'] + ': ' + (getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value']) : Metadata.TextStylesByCodename[style_name]['title']}}
									.right-control
										input.style-input.form-control.form-control-sm.custom-range(v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'number')" type="range" :min="Metadata.TextStylesByCodename[style_name]['min']" :max="Metadata.TextStylesByCodename[style_name]['max']" :step="Metadata.TextStylesByCodename[style_name]['step']" :value="getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value']" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
										input.style-input.form-control.form-control-sm(v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'color')" type="color" :value="getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value']" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
										input.style-input.form-control.form-control-sm(v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'string')" v-on:mousedown="textAreaOnDown($event)" type="text" :value="getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value']" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
										textarea.style-textarea(:ref="'styleTextarea-' + message_key + '-' + style_name" v-on:mousedown="textAreaOnDown($event)" v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'text')" :value="getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value']" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
										input.style-input.form-control.form-control-sm.switch-toggle(v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'boolean')" type="checkbox" :checked="getStyle(message_key, style_name)" @change="changeStyle(message_key, style_name, $event.target.checked)" data-checked="On" data-unchecked="Off")
										select.style-input.form-control.form-control-sm.custom-select(v-if="(Metadata.TextStylesByCodename[style_name]['type'] === 'select')" :value="getStyle(message_key, style_name) || Metadata.TextStylesByCodename[style_name]['value'] || Metadata.TextStylesByCodename[style_name]['values'][0]" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
											option(v-for="option in Metadata.TextStylesByCodename[style_name]['values']" :value="option") {{option}}
								.unknown-props(v-else)
									span.text-key.split-style-title.text-muted {{Metadata.TextStylesByCodename[style_name] ? Metadata.TextStylesByCodename[style_name]['title'] : style_name}}
									input.style-input.form-control.form-control-sm(type="text" :value="getStyle(message_key, style_name)" v-on:keyup="changeStyle(message_key, style_name, $event.target.value)" v-on:change="changeStyle(message_key, style_name, $event.target.value)")
								.controls-wrapper
									.button-wrapper
										button.form-control.form-control-sm.i.fa.fa-rotate-left.reset-style(v-if="isChangedStyle(message_key, style_name)" @click="resetStyle(message_key, style_name)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reset style to default'}")
									.button-wrapper
										button.form-control.form-control-sm.i.fa.fa-remove.remove-style(@click="removeStyle(message_key, style_name)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Remove style'}")
							.bottom-controls
								select.add-style.custom-select.custom-select-sm(v-on:change="addStyle(message_key, $event.target.value)")
									option(value="#add" selected) Add new style
									option(v-for="(styleProps, styleName) in Metadata.TextStylesByCodename" :value="styleName" v-if="(!text.styles.hasOwnProperty(styleName) || text.styles[styleName] === '#deleted#') && (styleProps.engines.includes(text.styles.type || Project.SelectedProject.engine) || Project.SelectedProject.type === 'end-card')") {{styleProps.title}}
								button.btn.btn-sm.btn-outline-secondary.delete-localization(v-if="messagesLanguage === 'en' && !isHasOrigin(message_key)" :class="{'btn-ghost-danger': deleteButtonHovering}" @mouseover="deleteButtonHovering = true" @mouseout="deleteButtonHovering = false" @click="removeLocalization(message_key, $event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Delete message for all locales'}") Delete
								button.form-control.form-control-sm.i.fa.fa-rotate-left.reset-all-styles(v-if="isChangedAnyStyle(message_key)" @click="resetAllStyles(message_key)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reset all styles to default'}")
				.add-message-container
					input.style-input.form-control.form-control-sm(type="text" placeholder="Write a new message here" v-model="newMessage")
					button.btn.btn-sm.btn-outline-secondary(v-on:click="addLocalization") Add
						i.fa.fa-plus
</template>

<script>

	import Screen 					from './../../mixins/screen';

	import { Project } 				from './../../services/Project'
	import { Settings } 			from './../../services/Settings'
	import { Localization } 		from './../../services/Localization'
	import { Layout } 				from './../../services/Layout'

	import SettingControls 			from './SettingControls.vue'
	import VersionAssetsSettingsVue from './VersionAssetsSettings.vue';

	export default {
		name: 'SettingsLocalization',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Selected Version Localization Changed",
				"Selected Version Localization Deleted",
				"Settings Tab Changed:localization"
			],
			events: {
				"Pseudo Modal Process Hide": function(names) {

					if (!this.expandedTextCodename) return;
					if (!_.includes(names, 'text-settings') && !_.includes(names, 'tutorial-arrow') && !this.textAreaSelecting) this.collapseTextSettings();

				}
			}
		},
		components: {
			SettingControls
		},
		data() {

			this.Project = Project;
			this.Settings = Settings;
			this.Localization = Localization;

			//https://www.science.co.il/language/Locale-codes.php -> Language code
			this.Languages = {
				"en": "English",
				"es": "Spanish",
				"de": "German",
				"fr": "French",
				"it": "Italian",
				"be": "Belgium",
				"dk": "Danish",
				"nl": "Dutch",
				"ru": "Russian",
				"pl": "Polish",
				"tr": "Turkish",
				"pt": "Portuguese",
				"ps": "Arabic",
				"no": "Norwegian",
				"sv": "Swedish",
				"fi": "Finnish",
				"sk": "Slovak",
				"cz" :"Czech",
				"hu": "Hungarian",
				"ja": "Japanese",
				"zh": "Chinese",
				"hk": "Chinese (Hong Kong)",
				"tw": "Chinese (Taiwan)",
				"kr": "Korean",
				"id": "Indonesian",
				"br": "Brazilian",
				"mx": "Mexican"
			};

			this.Texts = Localization.getVersionLocalization(Version.SelectedVersion) || {};

			this.setting = Settings.getSettingProps("locale");

			return {
				showed: true,
				language: 'en',
				messagesLanguage: 'en',
				expandedTextCodename: '',
				styleProps: {},
				newMessage: '',
				deleteButtonHovering: false
			};

		},
		methods: {

			textAreaOnDown(event) {
				this.textAreaSelecting = true;
				document.addEventListener('mouseup', () => {
					this.textAreaSelecting = false;
				}, {once: true});
			},

			expandTextSettings(message_key){

				this.expandedTextCodename = message_key;

				this.$nextTick(() => {

					Broadcast.call("Localization Message Expanded");

				});

			},

			collapseTextSettings() {

				this.expandedTextCodename = '';

				this.$nextTick(() => {

					Broadcast.call("Localization Message Collapsed");

				});

			},

			collectData() {

				if (Project.SelectedProject?.type === 'banner') return;

				this.Texts = Localization.getVersionLocalization(Version.SelectedVersion) || {};

				this.setting = Settings.getSettingProps("locale");

				if (!this.setting) return;

				this.language = Settings.getSettingValue(this.setting.codename);

			},

			setMessagesLanguage(lng) {

				Broadcast.call("Pseudo Modal Hide", ['localization-messages-dropdown']);

				this.messagesLanguage = lng;

			},

			getLocaleByLanguage(language) {

				if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.title === 'Kama Games') {
					if (language) {

						let locale = Object.keys(this.Languages).find(key => this.Languages[key] === language);

						if (locale) return locale;
						else return language === 'auto' ? language : 'en';

					} else {

						return language === 'auto' ? language : 'en';

					}
				}
				else {
					if (language) {

						let locale = Object.keys(this.Languages).find(key => this.Languages[key] === language);

						if (locale) return locale;
						else return 'en';

					} else {

						return 'en';

					}
				}

			},

			getMessage(message_key) {

				if (!this.Texts) return '';

				if (!this.Texts[this.messagesLanguage]) return '';

				if (this.expandedTextCodename === message_key && this.$refs['messageTextarea-' + message_key] && document.activeElement === this.$refs['messageTextarea-' + message_key][0]) {
					return document.activeElement.value;
				}

				return (this.Texts[this.messagesLanguage] && this.Texts[this.messagesLanguage][message_key]) ? this.Texts[this.messagesLanguage][message_key].message : '';

			},

			getStyle(message_key, style_name) {

				if (!this.Texts) return '';

				if (!this.Texts[this.messagesLanguage]) return '';

				let style_value = (this.Texts[this.messagesLanguage] && this.Texts[this.messagesLanguage][message_key]) ? this.Texts[this.messagesLanguage][message_key]['styles'][style_name] : '';

				let styleProps = Metadata.TextStylesByCodename[style_name];

				if (styleProps && styleProps.type === 'color' && typeof style_value === 'string' && style_value.indexOf('0x') === 0) style_value = '#' + style_value.substr(2);

				if (this.expandedTextCodename === message_key && styleProps && styleProps.type === 'text') {
					if (this.$refs['styleTextarea-' + message_key + '-' + style_name] && document.activeElement === this.$refs['styleTextarea-' + message_key + '-' + style_name][0]) {
						return document.activeElement.value;
					}
				}

				return style_value

			},

			changeMessage(message_key, text, timeout) {

				//Localization.Localization[text_id].message = text;

				clearTimeout(this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key]);
				this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key] = setTimeout(() => {

					Localization.changeLocalizationMessage(Version.SelectedVersion.id, this.messagesLanguage, message_key, text);

				}, timeout || 0);

				Broadcast.call("Localization Message Changed", [this.messagesLanguage, message_key, text]);

			},

			addStyle(message_key, style_name) {

				let style_value = Metadata.TextStylesByCodename[style_name].value;

				clearTimeout(this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key + '-' + style_name]);
				this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key + '-' + style_name] = setTimeout(() => {

					Server.sendToSocket({
						AddLocalizationStyle: {
							versionId: Version.SelectedVersion.id,
							locale: this.messagesLanguage,
							codename: message_key,
							styleName: style_name,
							styleValue: style_value
						}
					});

				}, 200);

			},

			changeStyle(message_key, style_name, style_value) {

				clearTimeout(this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key + '-' + style_name]);
				this['saveMessageTimeout-' + this.messagesLanguage + '-' + message_key + '-' + style_name] = setTimeout(() => {

					console.log('changeStyle1 style_value', style_value);

					style_value = Localization.checkLocalizationStyle(style_name, style_value);

					console.log('changeStyle2 style_value', style_value);

					Server.sendToSocket({
						ChangeLocalizationStyle: {
							versionId: Version.SelectedVersion.id,
							locale: this.messagesLanguage,
							codename: message_key,
							styleName: style_name,
							styleValue: style_value
						}
					});

				}, 200);

			},

			isChangedMessage(message_key) {

				return Localization.isLocalizationMessageChanged(Version.SelectedVersion, this.messagesLanguage, message_key);

			},

			resetMessage(message_key) {

				Server.sendToSocket({
					ResetLocalizationMessage: {
						versionId: Version.SelectedVersion.id,
						locale: this.messagesLanguage,
						codename: message_key
					}
				});

				Broadcast.call("Localization Message Changed", [this.messagesLanguage, message_key, Localization.LocalizationOriginalByVersionByLocaleByCodename[Version.SelectedVersion.id]?.[this.messagesLanguage]?.[message_key]?.message]);

			},

			isChangedStyle(message_key, style_name) {

				return Localization.isLocalizationStyleChanged(Version.SelectedVersion, this.messagesLanguage, message_key, style_name);

			},

			isChangedAnyStyle(message_key) {

				return Localization.isLocalizationStylesChanged(Version.SelectedVersion, this.messagesLanguage, message_key);

			},

			isHasOrigin(message_key) {

				return Localization.isLocalizationHasOrigin(Version.SelectedVersion, this.messagesLanguage, message_key);

			},

			resetStyle(message_key, style_name) {

				Server.sendToSocket({
					ResetLocalizationStyle: {
						versionId: Version.SelectedVersion.id,
						locale: this.messagesLanguage,
						codename: message_key,
						styleName: style_name
					}
				});

			},

			resetAllStyles(message_key) {

				Server.sendToSocket({
					ResetAllLocalizationStyles: {
						versionId: Version.SelectedVersion.id,
						locale: this.messagesLanguage,
						codename: message_key
					}
				});

			},

			removeStyle(message_key, style_name) {

				Server.sendToSocket({
					RemoveLocalizationStyle: {
						versionId: Version.SelectedVersion.id,
						locale: this.messagesLanguage,
						codename: message_key,
						styleName: style_name
					}
				});

				Broadcast.call("Localization Style Changed", [this.messagesLanguage, message_key, style_name, Metadata.TextStylesByCodename[style_name]?.value]);

			},

			addLocalization() {

				if (!this.newMessage) return;

				Server.sendToSocket({
					CreateLocalizationMessage: {
						versionId: Version.SelectedVersion.id,
						locale: this.messagesLanguage,
						message: this.newMessage
					}
				});

				this.newMessage = '';

			},

			removeLocalization(messageKey, e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete localization message',
					message: `Are you sure you want to delete localization message "${messageKey}"? It will delete all locales as well.`,
					confirmButtonText: '&nbsp;&nbsp;Delete message',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteLocalizationMessage: {
								versionId: Version.SelectedVersion.id,
								codename: messageKey
							}
						});
					}
				}]);

			}

		}

	}
</script>

<style lang="sass">

	.settings-localization

		input[type="color"].form-control.form-control-sm
			padding: 0.05rem

		.messages-area
			position: relative

			.messages-area-title
				.flag-icon
					width: 20px
					display: inline-block
					height: 15px
					margin-left: 10px

			.lang-chooser-control
				user-select: none

				.flag-icon
					width: 20px
					display: inline-block
					height: 15px

				.flag-title
					margin-left: 18px

			.messages
				position: relative
				margin-top: 5px
				border-radius: 5px
				font-size: 12px
				overflow: hidden
				background: #343b41
				border: 1px solid #23282c

			.split-input:last-child
				border-bottom: none

			.split-input
				display: block
				white-space: nowrap
				line-height: 25px
				border-bottom: 1px solid #2e3235

				.text-controls
					display: none

				.text-controls.expanded
					display: block

				.text-caption
					cursor: pointer
					color: #ffffff

					.title
						pointer-events: none

				.text-caption.has-expanded
					color: #73818f

				.text-caption.expanded
					cursor: default
					color: #ffffff

				textarea
					height: auto
					background-color: rgba(255,255,255,0.1)
					width: 100%
					border: none
					border-top: 1px solid #23282c
					border-bottom: 1px solid #23282c
					color: white
					padding: 0.5rem
					font-size: 0.9rem
					margin-bottom: 0px

				.split-title
					display: flex
					justify-content: space-between
					padding: 0 .5rem
					margin-bottom: 0
					font-size: 11px
					font-weight: 400
					white-space: nowrap
					margin-right: -1px
					background-color: #343b41
					text-overflow: ellipsis
					overflow: hidden
					user-select: none

				button.i.fa
					border: 0
					background-color: transparent
					background-clip: padding-box
					height: 25px
					color: #e4e7ea
					border-radius: 0
					margin-right: 19px
					width: 15px

				button.i.fa.remove-style
					display: none

				button.i.fa.reset-style:hover,
				button.i.fa.reset-message:hover,
				button.i.fa.remove-style:hover
					color: #20a8d8

				input
					margin-top: 2px
					border: 0
					border-bottom: 1px solid #23282c
					background-color: #515b65
					background-clip: padding-box
					height: 25px
					color: #e4e7ea
					border-radius: 0

				.bottom-controls
					display: flex
					justify-content: space-between
					align-items: center
					padding-bottom: 10px
					padding-left: 7px

					select.add-style

					button.delete-localization
						margin-right: 8px

					button.i.fa.reset-all-styles
						margin-right: 29px

					button.i.fa.reset-all-styles:hover
						color: #20a8d8

				.known-props, .unknown-props
					display: flex
					width: 86%
					gap: 10px

					.right-control
						display: flex
						padding: 2px 0 2px 0
						width: 57%

				.style-split-input:last-child
					border-bottom: none

				.style-split-input
					display: flex
					white-space: nowrap
					min-height: 28px
					justify-content: space-between
					padding-right: 5px

					.controls-wrapper
						display: flex
						flex-direction: row
						gap: 5px

						.button-wrapper
							width: 15px

						button
							padding: 0

					.split-style-title
						width: 40%
						margin-top: 0
						padding-left: .50rem
						margin-bottom: 0
						font-size: .75rem
						font-weight: 400
						line-height: 20px
						white-space: nowrap
						margin-right: -1px
						background-color: transparent
						background-clip: border-box
						text-overflow: ellipsis
						overflow: hidden
						user-select: none

					.style-textarea
						padding: 3px
						line-height: 11px
						font-size: 11px
						min-height: 46px
						width: 100%

					.style-input
						margin: 0
						border: none
						background-color: transparent
						background-clip: padding-box
						height: 24px
						max-height: 24px
						width: 140px
						color: #e4e7ea
						border-radius: 0

					.style-input.custom-range
						height: calc(1rem + 0.4rem)
						padding: 0
						background-color: transparent
						-webkit-appearance: none
						-moz-appearance: none
						appearance: none

					.style-input.custom-select
						cursor: pointer
						color: #fff
						width: 140px
						background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
						background-color: #343b41
						border: 1px solid #23282c
						border-radius: 5px
						margin-top: 0
						height: calc(1.5em + 0.5rem + 2px)
						padding-top: 0.1rem
						padding-bottom: 0.25rem
						padding-left: 0.5rem
						font-size: 0.75rem

					input[type="checkbox"]
						-webkit-appearance: none
						-moz-appearance: none
						appearance: none
						-webkit-tap-highlight-color: transparent
						cursor: pointer

						&:active, &:hover, &:focus
							outline: 0
							outline-offset: 0
							box-shadow: none

					input[type="color"]
						width: 140px

					input[type="number"]
						width: 140px

					input[type="text"]
						width: 140px
						border-radius: 0.2rem
						color: rgba(255, 255, 255, 0.87)
						background-color: rgba(255, 255, 255, 0.05)
						border: 1px solid rgba(255, 255, 255, 0.09)
						outline: none
						transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out

					input[type="text"]:focus-within
						border-color: rgba(255, 255, 255, 0.18)
						background-color: rgba(255, 255, 255, 0.10)
						color: rgba(255, 255, 255, 0.87)
						outline: none !important
						box-shadow: none

					.switch-toggle
						height: 22px
						width: 52px
						border-radius: 50em
						display: inline-block
						position: relative
						margin: 0
						background-color: #343b41
						border: 1px solid #23282c

						&:before
							position: absolute
							top: 2px
							left: 2px
							-webkit-box-sizing: border-box
							box-sizing: border-box
							width: 16px
							height: 16px
							content: ""
							background-color: #fff
							border: 1px solid #c8ced3
							-webkit-transition: .15s ease-out
							transition: .15s ease-out
							border-radius: 50em

						&:after
							position: absolute
							top: 50%
							right: 1px
							z-index: 1
							width: 50%
							margin-top: -.5em
							font-size: 9px
							font-weight: 600
							line-height: 1
							color: #c8ced3
							text-align: center
							text-transform: uppercase
							content: attr(data-unchecked)
							-webkit-transition: inherit
							transition: inherit

						&:checked
							background-color: #4dbd74

							&:after
								left: 2px
								content: attr(data-checked)
								color: white

							&:before
								left: auto
								right: 2px
								border-color: #3a9d5d

				.style-split-input:hover
					button.remove-style
						display: block

			.add-message-container
				display: flex
				flex-direction: row
				white-space: nowrap
				margin-top: 10px

				input

				input::placeholder
					color: rgba(255,255,255,0.3)

				button
					margin-left: 10px
					border: 1px solid #23282c
					border-radius: 3px

					i
						margin-left: 7px

		.flag-icon.en
			background: url("../../../public/Images/Icons/Flags/en.svg") center / cover no-repeat
		.flag-icon.es
			background: url("../../../public/Images/Icons/Flags/es.svg") center / cover no-repeat
		.flag-icon.de
			background: url("../../../public/Images/Icons/Flags/de.svg") center / cover no-repeat
		.flag-icon.mx
			background: url("../../../public/Images/Icons/Flags/mx.svg") center / cover no-repeat
		.flag-icon.fr
			background: url("../../../public/Images/Icons/Flags/fr.svg") center / cover no-repeat
		.flag-icon.it
			background: url("../../../public/Images/Icons/Flags/it.svg") center / cover no-repeat
		.flag-icon.be
			background: url("../../../public/Images/Icons/Flags/be.svg") center / cover no-repeat
		.flag-icon.nl
			background: url("../../../public/Images/Icons/Flags/nl.svg") center / cover no-repeat
		.flag-icon.dk
			background: url("../../../public/Images/Icons/Flags/dk.svg") center / cover no-repeat
		.flag-icon.ru
			background: url("../../../public/Images/Icons/Flags/ru.svg") center / cover no-repeat
		.flag-icon.pl
			background: url("../../../public/Images/Icons/Flags/pl.svg") center / cover no-repeat
		.flag-icon.tr
			background: url("../../../public/Images/Icons/Flags/tr.svg") center / cover no-repeat
		.flag-icon.pt
			background: url("../../../public/Images/Icons/Flags/pt.svg") center / cover no-repeat
		.flag-icon.ps
			background: url("../../../public/Images/Icons/Flags/ps.svg") center / cover no-repeat
		.flag-icon.no
			background: url("../../../public/Images/Icons/Flags/no.svg") center / cover no-repeat
		.flag-icon.sv
			background: url("../../../public/Images/Icons/Flags/sv.svg") center / cover no-repeat
		.flag-icon.cz
			background: url("../../../public/Images/Icons/Flags/cz.svg") center / cover no-repeat
		.flag-icon.fi
			background: url("../../../public/Images/Icons/Flags/fi.svg") center / cover no-repeat
		.flag-icon.sk
			background: url("../../../public/Images/Icons/Flags/sk.svg") center / cover no-repeat
		.flag-icon.hu
			background: url("../../../public/Images/Icons/Flags/hu.svg") center / cover no-repeat
		.flag-icon.ja
			background: url("../../../public/Images/Icons/Flags/jp.svg") center / cover no-repeat
		.flag-icon.zh
			background: url("../../../public/Images/Icons/Flags/cn.svg") center / cover no-repeat
		.flag-icon.hk
			background: url("../../../public/Images/Icons/Flags/hk.svg") center / cover no-repeat
		.flag-icon.tw
			background: url("../../../public/Images/Icons/Flags/tw.svg") center / cover no-repeat
		.flag-icon.kr
			background: url("../../../public/Images/Icons/Flags/kr.svg") center / cover no-repeat
		.flag-icon.id
			background: url("../../../public/Images/Icons/Flags/id.svg") center / cover no-repeat
		.flag-icon.br
			background: url("../../../public/Images/Icons/Flags/br.svg") center / cover no-repeat

</style>
